// The "You have been banned" popup: shown at most once per page, red OK signs
// the player out WITHOUT a final save push (their session is over) and wipes
// the local save like a normal logout.
import type { SupabaseClient } from '@supabase/supabase-js';
import { enqueueDevPopup } from '../ui/devPopup';
import { signOutUser } from './accountActions';
import { wipeLocalSave } from './saveSync';

let shown = false;

export function showBanPopup(client: SupabaseClient): void {
  if (shown) return;
  shown = true;
  enqueueDevPopup('ban', {
    onOk: () =>
      void (async () => {
        try {
          await signOutUser(client);
        } finally {
          wipeLocalSave(window.localStorage);
          window.location.reload();
        }
      })(),
  });
}
